export const AmenityRanking = {
  hotel: {
    wifi: 1,
    local_parking: 2,
    smoke_free: 3,
    room_service: 4,
    local_laundry_service: 5,
    pool: 6,
    restaurant: 7,
    local_bar: 8,
    luggage_storage: 9,
    airport_shuttle: 10,
    concierge_services: 11,
    business_center: 12,
    fitness_center: 13,
    'icon-wheat': 14,
    local_cafe: 15,
    smoking_rooms: 16,
    spa: 17,
    'communnity-waves': 18,
    waves: 18,
    'icon-nightclub': 19,
    hot_tub: 20,
    'communnity-tennis': 21,
    sports_tennis: 21,
    'icon-poolside-bar': 23,
  },
};
